import type {
  ConfirmAppointmentsOutputs,
  ConfirmAppointmentsStepId,
  ConfirmAppointmentsWorkflowEvent,
} from "../_shared/_logic/confirm-appointments-contract"

export const applyConfirmAppointmentsWorkflowEvent = (
  outputs: ConfirmAppointmentsOutputs,
  event: ConfirmAppointmentsWorkflowEvent,
): ConfirmAppointmentsOutputs => {
  if (event.type === "confirm.completed") {
    return { confirm: event.output }
  }

  if (event.type === "mail.completed") {
    return { ...outputs, mail: event.output }
  }

  if (event.type === "summary.finished") {
    return { ...outputs, summary: event.output }
  }

  return outputs
}

export const nextConfirmAppointmentsStep = (
  currentStep: ConfirmAppointmentsStepId,
  event: ConfirmAppointmentsWorkflowEvent,
): ConfirmAppointmentsStepId => {
  if (event.type === "go_to_step") return event.step

  if (event.type === "confirm.completed") return "mail"

  if (event.type === "mail.completed") return "summary"

  return currentStep
}

export const confirmAppointmentsStepIndex = (step: ConfirmAppointmentsStepId): number =>
  ["confirm", "mail", "summary"].indexOf(step)
